/* tslint:disable */

declare var Object: any;
export interface TenantExitTempInterface {
  "tenant_id": number;
  "lease_id": number;
  "exit_charges": Array<any>;
  "deposit_details"?: any;
  "unpaid_invoices"?: any;
  "wallet_details"?: any;
  "move_out_date"?: Date;
  "exit_checklist_filename"?: string;
  "refund_details"?: any;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
}

export class TenantExitTemp implements TenantExitTempInterface {
  "tenant_id": number;
  "lease_id": number;
  "exit_charges": Array<any>;
  "deposit_details": any;
  "unpaid_invoices": any;
  "wallet_details": any;
  "move_out_date": Date;
  "exit_checklist_filename": string;
  "refund_details": any;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  constructor(data?: TenantExitTempInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TenantExitTemp`.
   */
  public static getModelName() {
    return "TenantExitTemp";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TenantExitTemp for dynamic purposes.
  **/
  public static factory(data: TenantExitTempInterface): TenantExitTemp{
    return new TenantExitTemp(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TenantExitTemp',
      plural: 'TenantExitTemps',
      path: 'TenantExitTemps',
      idName: 'id',
      properties: {
        "tenant_id": {
          name: 'tenant_id',
          type: 'number'
        },
        "lease_id": {
          name: 'lease_id',
          type: 'number'
        },
        "exit_charges": {
          name: 'exit_charges',
          type: 'Array&lt;any&gt;'
        },
        "deposit_details": {
          name: 'deposit_details',
          type: 'any'
        },
        "unpaid_invoices": {
          name: 'unpaid_invoices',
          type: 'any'
        },
        "wallet_details": {
          name: 'wallet_details',
          type: 'any'
        },
        "move_out_date": {
          name: 'move_out_date',
          type: 'Date'
        },
        "exit_checklist_filename": {
          name: 'exit_checklist_filename',
          type: 'string'
        },
        "refund_details": {
          name: 'refund_details',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
      }
    }
  }
}
